import axios from "axios";
import Config from "../constants/config";
import nativeNormalize from "./normalize";

import { logout } from "../modules/auth/slice";

import * as localStorage from "./localStorage";

export const normalize = (json, opts = {}) => {
    const entities = nativeNormalize(json, opts);
    const { meta } = json;
    return { entities, meta };
};

axios.defaults.baseURL = Config.apiBaseUrl;

// Headers
axios.defaults.headers["Content-Type"] = "application/vnd.api+json";
axios.defaults.headers["Accept"] = "application/vnd.api+json";
axios.defaults.headers["Accept-Language"] = localStorage.getItem("locale") || "en";

/**
 * Response Interceptor
 */

export const setupResponseInterceptor = (store) =>
    axios.interceptors.response.use(
        (res) => {
            // Status code isn't a success code - throw error
            if (!`${res.status}`.startsWith("2")) {
                throw res.data;
            }

            const responseURL = res.config.url;

            if (responseURL.startsWith("auth/sign_in")) {
                const normalized = normalize(res.data.admin, { endpoint: responseURL });
                const token = { token: res.data.token };
                return { ...normalized, ...token };
            }
            if (
                responseURL.startsWith("projects/constants") ||
                responseURL.startsWith("/truck-types/filters") ||
                res?.config?.params?.hasOwnProperty("filter[nationalId]") ||
                responseURL.match(/^drivers\/\d+$/) ||
                responseURL.startsWith("/mezza_banks") ||
                responseURL.startsWith("/banks") ||
                responseURL.startsWith("locations/similarities") ||
                responseURL.match(/^\/trucks\/(\d+)$/) ||
                responseURL.match(/^\/suppliers\/(\d+)$/) ||
                responseURL.startsWith("/trucks/filter") ||
                responseURL.includes("summary")
            ) {
                return res.data;
            }

            return normalize(res.data, { endpoint: responseURL });
        },
        (error) => {
            // Pass the response from the API, rather than a status code
            if (error && error.response && error.response.data) {
                // Status code 401 - need to login
                if (error.response.status === 401) {
                    // logging out will change app auth state to not authorized which renders login page
                    store.dispatch(logout());
                }
                throw error.response.data;
            }
            throw error;
        }
    );

export const setupRequestInterceptor = (store) =>
    axios.interceptors.request.use((req) => {
        const { accessToken } = store.getState().auth;
        req.headers.common.Authorization = accessToken;
        return req;
    });
// Extract object to array of vlaues

export const convertListObjectToArray = (obj) => Object.values(obj);
export default axios;
